import React, { useState, useEffect } from "react";
import UserHeader from "./UserHeader";
import { Table } from "react-bootstrap";
import { getUserSurveyList } from "../../Utils/userFunctions";
import { ToastContainer, toast } from "react-toastify";
import dataTableGrid from "../DataTableGrid";
function UserListSurveys() {
  const [surveyList, setSurveyList] = useState("");
  useEffect(() => {
    async function fetchAPI11() {
      const response = await getUserSurveyList();
      if (response.status === "success" || response.status === "failure") {
        setSurveyList(response.optionItems);
        dataTableGrid({
          data_table_id: "#surveyList",
          paginate: false,
          copy_option: [],
          csv_option: [],
          print_option: [],
          sort_option: [],
        });
      } else {
        toast.error(response, { autoClose: 1500 });
      }
    }
    fetchAPI11();
  }, []);

  return (
    <div>
      <UserHeader />
      <ToastContainer></ToastContainer>
      <div className="container">
        <div className="row mt-4">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="card vd-card">
              <div className="card-body">
                <div className="card-table">
                  <div className="table-responsive">
                    <Table
                      id="surveyList"
                      bordered
                      size="sm"
                      className="table-sm"
                    >
                      <thead>
                        <tr>
                          <th>Sr.No</th>
                          <th>Device Name</th>
                          <th>Survey ID</th>
                          <th>Survey Name</th>
                          <th>Status</th>
                          <th>Created on</th>
                        </tr>
                      </thead>
                      <tbody>{surveyList}</tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default UserListSurveys;
